import { render, staticRenderFns } from "./ObservatoryLayer.vue?vue&type=template&id=7a145d2a&"
import script from "./ObservatoryLayer.vue?vue&type=script&lang=js&"
export * from "./ObservatoryLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports